/* eslint-disable */

import React from "react";
import { HiX } from "react-icons/hi";
import { MdLogout } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import Links from "./components/Links";

import routes from "routes.js";
import { APP_NAME } from "config/branding";
import { useShallow } from "zustand/react/shallow";
import { useEmissionAmbienteStore } from "stores/emissionAmbienteStore";
import { filterRoutesForSidebar } from "utils/sidebarRoutes";
import { useIdioma } from "stores/idiomaStore";

const Sidebar = ({ open, onClose }) => {
  const { t } = useIdioma();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const emission = useEmissionAmbienteStore(
    useShallow((s) => ({
      kind: s.kind,
      mixed: s.mixed,
      ambiente: s.ambiente,
    })),
  );
  const visibleRoutes = React.useMemo(
    () => filterRoutesForSidebar(routes, emission),
    [emission],
  );

  async function handleLogout() {
    await logout();
    navigate("/auth/sign-in", { replace: true });
  }

  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-screen w-full max-w-[313px] flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[56px] mt-[50px] flex items-center`}>
        <div className="mt-1 ml-1 max-w-[220px] font-poppins text-[20px] font-bold leading-tight text-navy-700 dark:text-white sm:text-[22px]">
          {APP_NAME}
        </div>
      </div>
      <div className="mt-[58px] mb-7 h-px bg-gray-300 dark:bg-white/30" />
      {/* Nav item */}

      <ul className="mb-auto pt-1">
        <Links routes={visibleRoutes} />
      </ul>

      <div className="mt-auto border-t border-gray-200 px-8 pt-5 pb-2 dark:border-white/10">
        <button
          type="button"
          onClick={handleLogout}
          className="flex w-full items-center gap-3 rounded-lg py-2.5 text-start text-sm font-medium text-gray-600 transition hover:bg-gray-50 hover:text-red-600 dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-red-400"
        >
          <MdLogout className="h-5 w-5 shrink-0" aria-hidden />
          {t("menu.cerrarSesion")}
        </button>
      </div>
 
      {/* Nav item end */}
    </div>
  );
};

export default Sidebar;
